import styled from 'styled-components';
import {
  mobile_width_percentage,
  tablet_breakpoint,
  tablet_container_maxwidth,
  desktop_breakpoint,
  desktop_container_maxwidth_compact,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

import chZindex from '@components/zIndex';

export const FindAHomeStyles = styled.div`
  .page-header {
    text-align: center;
    line-height: 12px;
    color: ${Colors.primary.white.standard};
    background: ${Colors.primary.claytonBlue.standard};
    padding: 24px;
  }

  .curated-buttons-container .curated-button-group .curated-buttons {
    justify-content: flex-start;
  }

  .loading-indicator {
    margin: auto;
  }
  .filters-bar-container {
    background-color: #fff;
    height: 60px;
    top: 0;
    z-index: ${chZindex.filterBars};

    &.sticky {
      position: sticky;
    }
  }
  .page-content {
    position: relative;
    width: ${mobile_width_percentage}%;
    margin: 0 auto;
    padding-top: 20px;
    min-height: 200px;

    .sort-bar-container {
      margin-bottom: 20px;
      .num-results {
        p {
          line-height: 2.53;
        }
      }
    }
    .home-cards-listing {
      > div {
        margin-bottom: 30px;
      }
    }
    .card-area-content {
      margin-bottom: 60px;
    }

    .card-image-area {
      .carousel-slider {
        img {
          pointer-events: all;
          transform: translateX(0px);
        }
        .slide {
          border-radius: 6px;
        }
        /* hide arrows for mobile */
        button {
          display: none;
        }
      }
      .card-image-single img {
        transform: translateX(0px);
        object-fit: cover;
      }
    }

    .carousel-root {
      width: 100%;
    }

    .control-dots .dot {
      margin: 0 6px;
      width: 7px;
      height: 7px;
    }

    .card-area-cta {
      .card-home-specs {
        display: none;
      }
      .card-info-area {
        > div {
          width: 100%;
        }
        .card-heading {
          position: relative;
          width: 100%;

          .heading-text {
            width: 90%;
          }
          .chevron {
            position: absolute;
            right: 0;
            top: 3px;
          }
        }
      }
    }
    .recently-viewed-container {
      margin: 40px 0;
    }
    .load-more {
      text-align: center;
      margin: 51px 0 35px 0;
      position: relative;

      button {
        margin: 0 auto;
      }
    }
    .disclaimer {
      margin-bottom: 49px;
    }
    .disclaimer-content {
      padding: 0;
      width: 100%;
    }
  }

  .carousel .slide .landscape img {
    width: auto;
    object-fit: cover;
  }

  .find-a-home-location-indicator-desktop > button {
    background: transparent;
  }

  @media only screen and (min-width: ${tablet_breakpoint}px) {
    .page-content {
      max-width: ${tablet_container_maxwidth}px;
      margin: 0 auto;

      .home-cards-listing {
        width: 100%;
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .page-content {
      margin-top: 20px;
      max-width: ${desktop_container_maxwidth_compact}px;

      .sort-bar-container {
        margin-bottom: 30px;
      }
      .home-cards-listing {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        > div {
          width: 31%;

          @media screen and (max-width: 960px) {
            width: 48%;
          }
        }
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint_extended}px) {
    .page-content {
      /* to display the circle with a chevron for prev/next arrows */
      .card-image-area {
        .carousel-slider {
          /* restore arrows for desktop */
          button {
            display: block;
          }
        }
      }
      .load-more {
        margin: 69px 0 40px 0;
      }
      .disclaimer {
        margin-bottom: 40px;
      }
    }
  }
`;

export default FindAHomeStyles;
